import { OverviewTabContainer } from '../../overviewTab/OverviewTabContainer';

/** Route element for Przeglad (/main/dod). */
export const OverviewRoute = (): JSX.Element => <OverviewTabContainer />;
